export const TextAlignList = [
  { value: 'left', label: '左揃え' },
  { value: 'center', label: '中央揃え' },
  { value: 'right', label: '右揃え' },
]